import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Alert } from 'antd';
import responseRate from '../../Actions/responseRate';

const { getServiceResponseRate } = responseRate.actions;

// Thresholds over the response rate (últimos 7 días) already exposed by the widget:
// >= 70% ok, [40%, 70%) intermittencies, < 40% critical (steer to the other channel).
const WARN_THRESHOLD = 70;
const CRITICAL_THRESHOLD = 40;

const SERVICE = {
    ws: 'Web Service',
    portal: 'Portal SAT',
};

class ServiceHealthWarning extends Component {
    componentDidMount() {
        // Shares the response-rate state fed by the header widget; the endpoint is
        // cached ~5 min server-side, so requesting it here is cheap and safe.
        if (!this.props.responseRateData) {
            this.props.getServiceResponseRate();
        }
    }

    getPercentage(requestType) {
        const data = this.props.responseRateData && this.props.responseRateData.data;
        if (!Array.isArray(data)) return null;
        const entry = data.find(d => d.requestType === requestType);
        return entry && typeof entry.answeredPercentage === 'number'
            ? entry.answeredPercentage
            : null;
    }

    level(pct) {
        if (pct === null) return 'unknown';
        if (pct < CRITICAL_THRESHOLD) return 'critical';
        if (pct < WARN_THRESHOLD) return 'warn';
        return 'ok';
    }

    render() {
        const wsPct = this.getPercentage('WS');
        const portalPct = this.getPercentage('Portal|Scraping');

        // No data yet (still loading / error) → don't show anything.
        if (wsPct === null && portalPct === null) return null;

        const wsCritical = this.level(wsPct) === 'critical';
        const portalCritical = this.level(portalPct) === 'critical';
        const wsWarn = this.level(wsPct) === 'warn';
        const portalWarn = this.level(portalPct) === 'warn';

        // Critical: alarming message; steer to the healthy channel when only one is down.
        if (wsCritical || portalCritical) {
            let message;
            if (wsCritical && portalCritical) {
                message = `Ambos servicios del SAT (${SERVICE.ws} y ${SERVICE.portal}) están presentando fallas graves. `
                    + 'Tus descargas podrían no completarse; te recomendamos intentar más tarde.';
            } else if (wsCritical) {
                message = `El servicio ${SERVICE.ws} del SAT está presentando fallas graves. `
                    + `Te recomendamos realizar tus descargas por ${SERVICE.portal} mientras se restablece.`;
            } else {
                message = `El servicio ${SERVICE.portal} del SAT está presentando fallas graves. `
                    + `Te recomendamos realizar tus descargas por ${SERVICE.ws} mientras se restablece.`;
            }
            return (
                <Alert
                    type="error"
                    showIcon
                    banner
                    message={message}
                    className="service-health-warning"
                    style={{ marginBottom: 16 }}
                />
            );
        }

        // Intermittencies on the degraded channel(s).
        if (wsWarn || portalWarn) {
            const degraded = [];
            if (wsWarn) degraded.push(SERVICE.ws);
            if (portalWarn) degraded.push(SERVICE.portal);
            const message = `El servicio de descarga del SAT (${degraded.join(' y ')}) está presentando `
                + 'intermitencias. Tus solicitudes podrían tardar más de lo normal o requerir reintento.';
            return (
                <Alert
                    type="warning"
                    showIcon
                    banner
                    message={message}
                    className="service-health-warning"
                    style={{ marginBottom: 16 }}
                />
            );
        }

        return null;
    }
}

const mapStateToProps = state => ({
    responseRateData: state.responseRate.responseRateData,
});

const mapDispatchToProps = dispatch => ({
    getServiceResponseRate() {
        dispatch(getServiceResponseRate());
    },
});

export default connect(mapStateToProps, mapDispatchToProps)(ServiceHealthWarning);
